import { chunk, orderBy } from 'lodash';
import { fetchDevices } from 'services/api/device/list';
import { getRentHistory } from 'services/api/payway/rentHistory';
import { getPurchaseButtonInfo } from 'services/api/payway/purchaseButtonInfo';
import * as actionType from './actionTypes';
import { purchaseButtonInfoService } from 'api/services/payway';
import { getRegion } from 'utils/Region';

export const onRentHistory = maxItems => (dispatch, getState) => {
  const claroAdEnable =
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.[
      getRegion()
    ]?.enable ||
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.default
      ?.enable;
  dispatch(actionType.rentHistoryBegin());
  return getRentHistory()
    .then(payload => {
      if (payload.errors) dispatch(actionType.rentHistoryError(payload));
      else {
        const parsedArray = payload.map(item => ({
          ...item,
          purchase_id: Number(item.purchase_id),
        }));

        const data = chunk(
          orderBy(parsedArray, ['purchase_id'], ['desc']),
          maxItems,
        );
        getRentInfo(data[0], claroAdEnable)
          .then(a => {
            data[0] = a;
            dispatch(actionType.rentHistorySuccess(data));
          })
          .catch(e => actionType.rentHistoryError(e));
      }
    })
    .catch(error => dispatch(actionType.rentHistoryError(error)));
};

export const onRentHistoryInfo = (data, partition) => async (
  dispatch,
  getState,
) => {
  const claroAdEnable =
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.[
      getRegion()
    ]?.enable ||
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.default
      ?.enable;
  dispatch(actionType.rentHistoryBegin());
  return getRentInfo(data[partition], claroAdEnable)
    .then(a => {
      const payload = data;
      payload[partition] = a;
      dispatch(actionType.rentHistorySuccess(payload));
    })
    .catch(e => dispatch(actionType.rentHistoryError(e)));
};

const getRentInfo = (rents, claroAdEnable) =>
  Promise.all(
    rents.map(async e => {
      const purchaseId = {
        purchase_id: e.purchase_id,
      };
      const { response, status: statusDev } = await fetchDevices(purchaseId);
      const purchase = await purchaseButtonInfoService({
        group_id: e.common.id,
        claroAdEnable: claroAdEnable,
      });
      const statusDevice = parseInt(statusDev, 10);
      if (statusDevice === 0 || statusDevice === 200) {
        e.device = [];
        if (response.devices.length > 0) {
          response.devices.map(d => {
            const device = d;
            device.purchase_id = e.purchase_id;
            return device;
          });
          e.device = response.devices;
        }
      }
      e.purchase = purchase;
      e.apply = true;
      return e;
    }),
  );
